import { Link } from 'react-router-dom';

export function PartnerSignupLoginLink() {
  return (
    <div className="mt-6 text-center">
      <span className="text-sm text-black">
        Já possui uma conta?{' '}
      </span>
      <Link to="/login" className="text-sm text-black underline">
        Entrar
      </Link>
    </div>
  );
}
